import { Group, Stack, Text } from '@mantine/core';
import {
  IconCircleNumber1,
  IconCircleNumber2,
  IconCircleNumber3,
  IconCircleNumber4,
  IconCircleNumber5,
  IconRobot,
} from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

export const NoDataTip = () => {
  const { t } = useTranslation();
  return (
    <div className="h-full flex justify-center items-center">
      <Stack className="rounded-md -translate-y-16">
        <IconRobot size={100} strokeWidth={1} />
        <Text size="lg" fw={700}>
          {t('collaborative.nodata.title')}
        </Text>
        <Text size="sm" c="gray.5">
          {t('collaborative.nodata.desc')}
        </Text>
        <Stack>
          <Group wrap="nowrap">
            <IconCircleNumber1 className="flex-shrink-0" />
            <Text>{t('collaborative.nodata.step1')}</Text>
          </Group>
          <Group wrap="nowrap">
            <IconCircleNumber2 className="flex-shrink-0" />
            <Text>{t('collaborative.nodata.step2')}</Text>
          </Group>
          <Group wrap="nowrap">
            <IconCircleNumber3 className="flex-shrink-0" />
            <Text>{t('collaborative.nodata.step3')}</Text>
          </Group>
          <Group wrap="nowrap">
            <IconCircleNumber4 className="flex-shrink-0" />
            <Text>{t('collaborative.nodata.step4')}</Text>
          </Group>
          <Group wrap="nowrap">
            <IconCircleNumber5 className="flex-shrink-0" />
            <Text>{t('collaborative.nodata.step5')}</Text>
          </Group>
        </Stack>
      </Stack>
    </div>
  );
};
